import { ErrorOutlineIcon, Flex, Text } from '@shared/components';

export interface ErrorPageComponentProps {
  message?: string;
  detail?: string;
}

export default function ErrorPageComponent(props: Readonly<ErrorPageComponentProps>) {
  const { message, detail } = props;
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: (theme) => theme.spacing(2),
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 80, color: 'primary.main', mb: 4 }} />
      <Text variant='h3'>{message}</Text>
      <Text variant='body2' color='text.secondary'>
        {detail}
      </Text>
    </Flex>
  );
}
